export function initSkeleton() {
  const skeletons = document.querySelectorAll('[data-skeleton]');
  if (!skeletons.length) return;

  setTimeout(() => {
    skeletons.forEach(el => {
      const target = document.querySelector(`[data-skeleton-target="${el.dataset.skeleton}"]`);
      el.classList.add('hidden');
      if (target) target.classList.remove('hidden');
    });
  }, 1200);
}
